import styled from 'styled-components';
import LogoIcon from '@assets/images/logo.svg';


export const HeaderDiv = styled.div`
  display: flex;
  align-items: center;
`;

export const HeaderWrapper = styled.div`
  border-bottom: solid 0.5px;
  border-image: linear-gradient(225deg, #89DD65 0%, #AEDD65 100%);
  border-image-slice: 1;
  position: fixed;
  width: 100%;
  top: 0;
  background-color: #F5F5F7;
  z-index: 100;
  transform: ${props => props.hide ? `translate(0%,-100%)` : ''};
  transition: all 0.3s ease-in-out;
`;

export const UlNav = styled.ul`
  display: flex;
  list-style: none;
  /* margin-top: 37px; */
  margin-left: auto;
  padding: 0;
`;

export const Button = styled.div`
  width: 163px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 15px;
  line-height: 25px;
  background: linear-gradient(225deg, #89DD65 0%, #AEDD65 100%);
  border-radius: 50px;
  cursor: pointer;
`

export const LiNav = styled.li`
  margin-right: 40px;
  color: #121212;

  ${props => props.colored ? `
    a {
      color: #89DD65;
    }
  ` : ''};

  &:last-child {
    margin-right: 0;
  }

  a {
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 35px;
    cursor: pointer;
    text-decoration: none;

    &:hover {
      /* background: linear-gradient(225deg, #89DD65 0%, #AEDD65 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent; */
      color: #89DD65;
    }
  }
`;

export const Logo = styled.div`
  display: flex;
  min-width: 165px;
  height: 90px;
  justify-content: center;
  align-items: center;
  /* margin-top: 12px; */
  text-decoration:none;
  cursor: pointer;
`;

export const Line = styled.span`
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  font-size: 30px;
  line-height: 90px;
  margin: 0 15px;
  color: #121212;
`;

export const LogoSpan = styled.span`
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 30px;
  line-height: 90px;
  color: #121212;
`

export const LogoIconElement = styled(LogoIcon)`
  cursor: pointer;
`;